import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { AllianceApi } from 'src/app/shared/apis/alliance.api';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { FriendService } from '../../../friend.service';
export type DialogDataSubmitCallback<T> = (row: T) => void;
@UntilDestroy()
@Component({
  selector: 'app-referral-id',
  templateUrl: './referral-id.component.html',
  styleUrls: ['./referral-id.component.scss'],
})
export class ReferralIdComponent implements OnInit {
  isH5!: boolean;
  /** 推荐ID */
  referralId!: string;
  constructor(
    private layout: LayoutService,
    private dialogRef: MatDialogRef<ReferralIdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { callback: DialogDataSubmitCallback<any>; isSave: boolean },
    public appService: AppService,
    private allianceApi: AllianceApi,
    private friendService: FriendService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => (this.isH5 = e));
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    if (!this.referralId) {
      return;
    }
    this.allianceApi.registerNewReferral(this.referralId, this.appService.userInfo$.value?.uid || '').subscribe(res => {
      if (res.code == 200) {
        this.friendService.isShowLeftMenuReferraslId$.next(false);
        this.dialogRef.close();
      } else {
        this.toast.show({ message: res.message });
      }
    });
  }
}
